/**
 * Frontend feature flags.
 *
 * Toggle UI visibility without touching backend or data.
 * Default values are intentionally conservative (most features off on production).
 *
 * To override at build time, set `REACT_APP_FF_<NAME>=true|false` in `frontend/.env`.
 * Example: `REACT_APP_FF_SHOW_LANGUAGE_SELECTOR=true`
 */

const readBoolEnv = (name, defaultValue) => {
  const raw = process.env[name];
  if (raw === undefined || raw === null || raw === '') return defaultValue;
  return String(raw).toLowerCase() === 'true';
};

export const FEATURE_FLAGS = {
  // Show the "Land & Sprog" section in Settings. Default OFF on production.
  show_language_selector: readBoolEnv('REACT_APP_FF_SHOW_LANGUAGE_SELECTOR', false),
};

export const isFeatureEnabled = (flagName) => Boolean(FEATURE_FLAGS[flagName]);
